import React, { Fragment, useEffect, useRef, useState } from 'react';
import './home.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../Redux/ActionCreators/profileAction';
import { getBanners, getTestimonials, getNewsList, getNextNewsList } from '../../Redux/ActionCreators/homepageAction';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { SampleNextArrow, SamplePrevArrow } from '../../utils/miscellneous';
import { Helmet } from "react-helmet";
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';




export default function Home() {
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const recipeData = useSelector(state => state.home);
    const { allBanners, testimonials, newsList } = recipeData

    useEffect(() => {
        window.scrollTo(0, 0);
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        };
        const firstRender = async () => {
            localStorage.getItem('userAuthToken') && dispatch(getProfile());
            await dispatch(getBanners());
            await dispatch(getNewsList(1));
            await dispatch(getTestimonials());
        }
        firstRender();
    }, [])

    const fetchData = () => {
        setPage(page + 1);
        dispatch(getNextNewsList(page + 1));
    }

    useEffect(() => {
        const carouselInstance = new window.bootstrap.Carousel(carouselRef.current);
        setTimeout(() => {
            carouselInstance.cycle();
        }, 3000)
    }, [])

    const carouselRef = useRef();
    var settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <SampleNextArrow className={"next-arrow"} />,
        prevArrow: <SamplePrevArrow className={"prev-arrow"} />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1008,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }

        ]
    };
    return (
        <div className='homepage-holder mb-0'>
            <Helmet>
                <meta charSet="utf-8" />
                <title>NutrAInn | Speed up the R&D process exponentially for your Nutraceutical, Food & Beverage Organization</title>
                <meta name="description" content="NutrAInn is a powerful and innovative recipe maker for global Food & Beverage industry, speeding up the R&D process exponentially" />
                <link rel="canonical" href="https://www.nutrainn.com/" />
            </Helmet>
            <div className='banner-holder position-relative'>
                <div id="carouselExampleCaptions" ref={carouselRef} className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
                    <div className="carousel-indicators">
                        {
                            allBanners?.map((el, index) => {
                                return (
                                    <button key={el.id} type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to={`${index}`} className="active" aria-current="true" aria-label={`Slide ${index}`}></button>
                                )
                            })
                        }
                    </div>
                    <div className="carousel-inner" >
                        {
                            allBanners?.map((el, index) => {
                                return (
                                    <div key={el.id} className={index === 0 ? "carousel-item active" : "carousel-item"}>
                                        <img src={el.image} className="d-block w-100 banner-img" alt="..." style={{ aspectRatio: '211 / 35' }} />
                                    </div>
                                )
                            })
                        }

                    </div>
                </div>

            </div>
            <div className='aboutus'>
                {/* <h3>About Us</h3> */}
                <div className='d-flex'>
                    {window.innerWidth > 767 &&
                        <div className='static-text'>
                            <h3>NutrAInn AI </h3>

                            <p><strong>NutrAInn</strong> speeds up the R&D process exponentially for Nutraceutical, and Food & Beverage manufacturing, with its unlimited cost-saving creative recipes, demonstrating a complete nutrition value chart, meeting the norms your countries nutrition institute.</p>

                            <p><strong>NutrAInn</strong> is a one stop innovative solution for market ready food products, tailored to any Servings & Shelf-Life needs; you name it for, "Energy Bars for Weight Loss", "Low-Glycemic Index Cookies", "High protein meal", & "Whey Protein Powder with Immunity & Electrolyte Boosters", and many others. </p>

                            <p><strong>NutrAInn</strong> provides out of the box marketing ideas visually for product labeling. </p>
                        </div>}
                    <img src='./images/background-images/home-static.png' className='w-100' alt='' />
                </div>
            </div>
            <div className='build-news-recipe'>
                <div className='homepage'>
                    {newsList?.length ?
                        <div className='news'>
                            <h3>Recent News</h3>
                            <div style={{ paddingTop: 0 }}>

                                <div id="scrollableDiv1" className='subcatalog-cards overflow-cuisine' style={{
                                    maxHeight: window.innerWidth > 767 ? 815 : 600,
                                    overflow: 'auto',
                                    overflowX: 'hidden', borderBottomLeftRadius: 4, borderBottomRightRadius: 4, paddingRight: 10,
                                    marginTop: 20
                                }}>
                                    <InfiniteScroll
                                        dataLength={newsList && newsList?.length} //This is important field to render the next data
                                        next={fetchData}
                                        hasMore={true}
                                        style={{ overflow: 'unset' }}
                                        scrollableTarget="scrollableDiv1"
                                    >
                                        <div className='row   align-self-stretch'>
                                            {
                                                newsList?.map(el => {
                                                    return (
                                                        <div key={el.id} onClick={() => navigate('/news', { state: { data: el.data } })} className='col-md-3 mt-3 pe-0 d-flex justify-content-center'>
                                                            <div class="card cursor-pointer" style={{ padding: 10 }} >
                                                                <img src={el.data.news_image} class="card-img-top" alt="..." height={200} />
                                                                <div class="card-body">
                                                                    <p class="card-text" >{el.data.news_heading}</p>
                                                                    <div className='d-flex justify-content-between align-items-center mt-3'>
                                                                        <span>{moment(el.data.published_date).format('D MMMM, YYYY')}</span>
                                                                        <img src='./svg-icons/circle-right.svg' alt='' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </InfiniteScroll>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                    <div className='news news-slider'>
                        <h3>Client Testimonials</h3>
                        <div className='position-relative mt-4'>
                            <Slider {...settings}>
                                {
                                    testimonials?.map(el => {
                                        return (
                                            <div className='col-md-4 mt-3 '>
                                                <div class="card"   >
                                                    <div class="card-body">
                                                        <p class="card-text testimonial-text">{el.testimonialText}</p>
                                                        <div className='d-flex  align-items-center mt-4' >
                                                            <div >
                                                                <img src={el.image ? el.image : './images/user1.jpg'} alt='' className='user-img' />
                                                            </div>&nbsp;&nbsp;&nbsp;
                                                            <div>
                                                                <h6>{el.clientName}</h6>
                                                                <h5>{el.designation}</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                </div>

            </div>
            <div className='contactus-section' style={{ backgroundImage: `url('./images/contactus.jpeg')` }}>
                <div className='overlay'></div>
                <div className='center-text'>
                    <h2>Ready to Collaborate, Let’s Chat</h2>
                    <p>The strongest relationships and collaborations start with
                        meaningful conversations. <br />Our team of experts will be happy to assist with you.</p>
                    <div className='mt-3 text-center'>
                        <button onClick={() => navigate('contact-us')}>Contact us Today</button>
                    </div>
                </div>
            </div>
        </div >
    )
}

